/**
 * Resolução de tema — regra pura, separada do componente React.
 *
 * É decisão de produto ("system segue o sistema; sem informação, claro" —
 * PO, 17/09/2026, lote de aparência 1; antes a reserva era o escuro),
 * então vive num módulo sem JSX, testável sem runtime de React Native.
 */

import type { ThemeName } from './colors.js';

export type ThemePreference = ThemeName | 'system';

export function resolveThemeName(
  preference: ThemePreference,
  systemScheme: 'light' | 'dark' | null | undefined,
): ThemeName {
  if (preference !== 'system') return preference;
  // Sem informação do sistema, claro (decisão do PO, 17/09/2026).
  return systemScheme === 'dark' ? 'dark' : 'light';
}
